import React from 'react'

const SerCardSingle = (props) => {
    return (
        <>
            <div className="cards">
                <div className="icon">
                    <i className={props.clas}></i>
                </div>
                <h4>{props.head}</h4>
                <p>{props.description}</p>
            </div>
        </>
    )
}

export default SerCardSingle